import React from 'react';
import { Box, Tab, Divider, Paper } from '@material-ui/core';
import { TabContext, TabList } from '@material-ui/lab';

import ManageMachine from '../ManageMachine/ManageMachine';
import ManageGame from '../ManageGame/ManageGame';
import AssignGameToMachine from '../assignGameToMachine/AssignGameToMachine';
import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';

import withShipment from '../../../withShipment';
import { userInfoSelector } from '../../../redux/selectors/auth';

import './SetupMachines.css';

const TAB_KEYS = {
  MACHINES: '1',
  GAMES: '2',
  ASSIGN: '3',
};

const TAB_TITLES = {
  [TAB_KEYS.MACHINES]: 'Machines Setup',
  [TAB_KEYS.GAMES]: 'Game Type',
  [TAB_KEYS.ASSIGN]: 'Set Machine Readings',
};

const sameMenuItems = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (a[i].title !== b[i].title || a[i].disabled !== b[i].disabled) {
      return false;
    }
  }
  return true;
};

class SetupMachines extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tabValue: this.getInitialTab(props),
      menuItemsByTab: {
        [TAB_KEYS.MACHINES]: [],
        [TAB_KEYS.GAMES]: [],
        [TAB_KEYS.ASSIGN]: [],
      },
    };
  }

  setTabMenuItems = (tabKey) => (items) => {
    this.setState((prev) => {
      const current = prev.menuItemsByTab[tabKey] || [];
      if (sameMenuItems(current, items)) return null;
      return {
        menuItemsByTab: { ...prev.menuItemsByTab, [tabKey]: items },
      };
    });
  };

  getInitialTab(props) {
    const routes = props.userInfo?.routes || [];
    if (routes.includes('machine')) return TAB_KEYS.MACHINES;
    if (routes.includes('game')) return TAB_KEYS.GAMES;
    if (routes.includes('assign-machine')) return TAB_KEYS.ASSIGN;
    return TAB_KEYS.MACHINES;
  }

  hasAccess = (id) => {
    const routes = this.props.userInfo?.routes || [];
    return routes.includes(id);
  };

  renderTabLabel = (label) => (
    <Box display="flex" alignItems="center" gap={1}>
      {label}
    </Box>
  );

  render() {
    const showMachines = this.hasAccess('machine');
    const showGames = this.hasAccess('game');
    const showAssign = this.hasAccess('assign-machine');

    const activeTitle = TAB_TITLES[this.state.tabValue] || 'Setup Machines';
    const activeMenuItems = this.state.menuItemsByTab[this.state.tabValue] || [];

    return (
      <Paper className="paper">
        <TopToolbar pageName={activeTitle} menuItems={activeMenuItems} />
        <Box className="setup-machines-shell">
          <TabContext value={this.state.tabValue}>

            <Box className="setup-machines-tabbar">
              <TabList
                onChange={(e, val) => this.setState({ tabValue: val })}
                aria-label="setup machines tabs"
                sx={{
                  minHeight: 48,
                  '& .MuiTabs-indicator': {
                    height: 3,
                    borderRadius: 2,
                    backgroundColor: '#3F51B5',
                  },
                }}
              >
                {showMachines && (
                  <Tab
                    value={TAB_KEYS.MACHINES}
                    disableRipple
                    label={this.renderTabLabel('Machines Setup')}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: 14,
                      color: this.state.tabValue === TAB_KEYS.MACHINES ? '#111' : '#6B7280',
                      minHeight: 48,
                    }}
                  />
                )}
                {showMachines && showGames && (
                  <Divider
                    style={{
                      width: '1px',
                      height: '22px',
                      backgroundColor: '#a2b5d7',
                      alignSelf: 'center',
                      marginLeft: 4,
                      marginRight: 4,
                    }}
                  />
                )}
                {showGames && (
                  <Tab
                    value={TAB_KEYS.GAMES}
                    disableRipple
                    label={this.renderTabLabel('Game Type')}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: 14,
                      color: this.state.tabValue === TAB_KEYS.GAMES ? '#111' : '#6B7280',
                      minHeight: 48,
                    }}
                  />
                )}
                {(showMachines || showGames) && showAssign && (
                  <Divider
                    style={{
                      width: '1px',
                      height: '22px',
                      backgroundColor: '#a2b5d7',
                      alignSelf: 'center',
                      marginLeft: 4,
                      marginRight: 4,
                    }}
                  />
                )}
                {showAssign && (
                  <Tab
                    value={TAB_KEYS.ASSIGN}
                    disableRipple
                    label={this.renderTabLabel('Set Machine Readings')}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: 14,
                      color: this.state.tabValue === TAB_KEYS.ASSIGN ? '#111' : '#6B7280',
                      minHeight: 48,
                    }}
                  />
                )}
              </TabList>
            </Box>

            {/* Render all tabs permanently so local state (unsaved machines)
                survives tab switches. Use display:none instead of TabPanel's
                unmount-on-hide behavior. */}
            <Box className="setup-machines-scroll">
              {showMachines && (
                <div style={{ display: this.state.tabValue === TAB_KEYS.MACHINES ? 'block' : 'none' }}>
                  <ManageMachine
                    embedded
                    onMenuItemsChange={this.setTabMenuItems(TAB_KEYS.MACHINES)}
                  />
                </div>
              )}
              {showGames && (
                <div style={{ display: this.state.tabValue === TAB_KEYS.GAMES ? 'block' : 'none' }}>
                  <ManageGame
                    embedded
                    onMenuItemsChange={this.setTabMenuItems(TAB_KEYS.GAMES)}
                  />
                </div>
              )}
              {showAssign && (
                <div style={{ display: this.state.tabValue === TAB_KEYS.ASSIGN ? 'block' : 'none' }}>
                  <AssignGameToMachine
                    embedded
                    onMenuItemsChange={this.setTabMenuItems(TAB_KEYS.ASSIGN)}
                  />
                </div>
              )}
            </Box>
          </TabContext>
        </Box>
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
});

export default withShipment({ mapStateToProps }, SetupMachines);
